import type { AxiosError } from 'axios';
import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import { fetchIdentityProviders, IDENTITY_PROVIDERS_QUERY_KEY } from '../api';
import { identityProviderDtoToModel } from '../mapper';
import type { IdentityProviderModel } from '../model';

export function useIdentityProviderList(
  accountId: number | null,
): UseQueryResult<IdentityProviderModel[], AxiosError> {
  return useQuery<IdentityProviderModel[], AxiosError>(
    [IDENTITY_PROVIDERS_QUERY_KEY, accountId],
    async () => {
      const identityProviders = await fetchIdentityProviders(accountId as number);
      return identityProviders.map(identityProviderDtoToModel);
    },
    {
      enabled: !!accountId,
      cacheTime: 60 * 1000, // 1 minute
      placeholderData: [],
      refetchOnWindowFocus: false,
    },
  );
}
